import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Typography } from '@popmenu/common-ui';
import { useIntl } from 'react-intl';

import { withStyles } from '../../../utils/withStyles';
import birthdayFieldStyles from '../../../assets/jss/shared/birthdayFieldStyles';

import FormGroup from '../../../admin/shared/forms/FormGroup';
import Grid from '../../Grid';
import SelectGroup from '../../../admin/shared/forms/SelectGroup';

const BirthdayFields = ({
  classes,
  variant = 'standard',
}) => {
  const intl = useIntl();
  const months = [
    intl.formatMessage({ defaultMessage: 'January' }),
    intl.formatMessage({ defaultMessage: 'February' }),
    intl.formatMessage({ defaultMessage: 'March' }),
    intl.formatMessage({ defaultMessage: 'April' }),
    intl.formatMessage({ defaultMessage: 'May' }),
    intl.formatMessage({ defaultMessage: 'June' }),
    intl.formatMessage({ defaultMessage: 'July' }),
    intl.formatMessage({ defaultMessage: 'August' }),
    intl.formatMessage({ defaultMessage: 'September' }),
    intl.formatMessage({ defaultMessage: 'October' }),
    intl.formatMessage({ defaultMessage: 'November' }),
    intl.formatMessage({ defaultMessage: 'December' }),
  ];
  return (
    <FormGroup className={classes.formGroup}>
      <Typography className={classes.title}><FormattedMessage defaultMessage="Birthday" /></Typography>
      <Grid container>
        <Grid item xs={6}>
          <SelectGroup
            aria-label={intl.formatMessage({ defaultMessage: 'Birth Month' })}
            field="birthMonth"
            isSearchable={false}
            options={months.map((label, i) => ({
              label,
              value: i + 1,
            }))}
            placeholder={intl.formatMessage({ defaultMessage: 'Birth Month' })}
            variant={variant}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectGroup
            aria-label={intl.formatMessage({ defaultMessage: 'Birth Day' })}
            field="birthDay"
            isSearchable={false}
            options={[...Array(32).keys()].splice(1).map(day => ({
              label: String(day),
              value: day,
            }))}
            placeholder={intl.formatMessage({ defaultMessage: 'Birth Day' })}
            variant={variant}
          />
        </Grid>
      </Grid>
    </FormGroup>
  );
};

BirthdayFields.propTypes = {
  classes: PropTypes.object.isRequired,
  variant: PropTypes.string,
};

export default withStyles(birthdayFieldStyles)(BirthdayFields);
